import React from 'react';
import styled from 'styled-components';
import SectionContainer from '../components/SectionContainer';
import PageHeader from '../components/PageHeader';

const RetombeesPressePageContainer = styled.div`
  padding-top: var(--spacing-xl);
`;

const FeaturedSection = styled.section`
  margin: var(--spacing-lg) 0 var(--spacing-xl);
  padding: var(--spacing-lg) var(--spacing-md);
  background-color: var(--color-light-gray, #f8f8f6);
  border-radius: var(--border-radius);
`;

const FeaturedHeader = styled.div`
  text-align: center;
  margin-bottom: var(--spacing-lg);
`;

const FeaturedEyebrow = styled.span`
  display: inline-block;
  font-size: 0.75rem;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--color-text-secondary, #888);
  margin-bottom: var(--spacing-xs);
`;

const FeaturedTitle = styled.h2`
  font-size: 1.8rem;
  font-weight: 400;
  margin: 0 0 var(--spacing-xs);
  letter-spacing: 0.02em;
`;

const FeaturedSubtitle = styled.p`
  font-size: 1rem;
  font-style: italic;
  color: var(--color-text-secondary, #666);
  margin: 0;
  font-family: var(--font-body);
`;

const FeaturedGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: var(--spacing-md);
`;

const PressGalleryContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: var(--spacing-md);
  margin-top: var(--spacing-lg);
  padding: 0 var(--spacing-md);
`;

const PressImage = styled.img`
  width: 100%;
  height: 400px;
  object-fit: cover;
  border-radius: var(--border-radius);
  box-shadow: var(--box-shadow-sm);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: var(--box-shadow-md);
  }
`;

const RetombeesPressePage: React.FC = () => {
  // Parution mise en avant : Art & Décoration N°601 (images 061-067)
  const featuredImages = [];
  for (let i = 61; i <= 67; i++) {
    const imageNumber = i.toString().padStart(3, '0');
    featuredImages.push({
      src: `/images/presse/Agence_Interieurs_Presse-${imageNumber}.jpg`,
      alt: `Art & Décoration N°601 - Page ${i - 60}`
    });
  }

  // Anciennes couvertures de magazines (en tête de galerie, juste après la section à la une)
  const pressImages = [
    { src: '/images/magazine1.png', alt: 'Magazine 1' },
    { src: '/images/magazine2.png', alt: 'Magazine 2' },
    { src: '/images/magazine3.png', alt: 'Magazine 3' }
  ];

  // Autres parutions : images 060 → 001 (plus récentes en premier)
  for (let i = 60; i >= 1; i--) {
    const imageNumber = i.toString().padStart(3, '0');
    if (i !== 15 && i !== 17) {
      pressImages.push({
        src: `/images/presse/Agence_Interieurs_Presse-${imageNumber}.jpg`,
        alt: `Retombée Presse ${i}`
      });
    }
  }

  return (
    <RetombeesPressePageContainer>
      <SectionContainer>
        <PageHeader
          title="Retombées Presse"
          subtitle="Nos apparitions dans les médias"
        />

        <FeaturedSection>
          <FeaturedHeader>
            <FeaturedEyebrow>À la une</FeaturedEyebrow>
            <FeaturedTitle>Art &amp; Décoration N°601</FeaturedTitle>
            <FeaturedSubtitle>
              Janvier / Février 2026 — «&nbsp;Entre héritage et esprit 70's&nbsp;»
            </FeaturedSubtitle>
          </FeaturedHeader>
          <FeaturedGrid>
            {featuredImages.map((image, index) => (
              <PressImage
                key={`featured-${index}`}
                src={image.src}
                alt={image.alt}
                loading="lazy"
              />
            ))}
          </FeaturedGrid>
        </FeaturedSection>

        <PressGalleryContainer>
          {pressImages.map((image, index) => (
            <PressImage
              key={index}
              src={image.src}
              alt={image.alt}
              loading="lazy"
            />
          ))}
        </PressGalleryContainer>
      </SectionContainer>
    </RetombeesPressePageContainer>
  );
};

export default RetombeesPressePage;
